var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.isAdmin)?_c('Header'):_vm._e(),_c('router-view'),(!_vm.$route.meta.isAdmin)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }